import { render, staticRenderFns } from "./FAddBtn.vue?vue&type=template&id=7d84f836&"
import script from "./FAddBtn.vue?vue&type=script&lang=ts&"
export * from "./FAddBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports